import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { getDocPreviewUrl } from "../../services/DocPreviewService";

// Vista previa de un documento: pide la URL firmada (60 s) al montarse; el
// listado de pax ya no trae URLs.
const DocPreviewImage = ({ paxId, side }) => {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    getDocPreviewUrl(paxId, side).then(res => {
      if (!active) return;
      setUrl(res);
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, [paxId, side]);

  if (loading) return <CircularProgress size={24} />;
  if (!url) return null;
  return (
    <img
      src={url}
      alt={side}
      style={{ width: "100%", height: "100%", objectFit: "contain" }}
    />
  );
};

export default DocPreviewImage;
